import React from 'react';
import { CheveronRightIcon } from '@wkda/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Button = props => {
  const {
    className,
    svgChevron,
    data: {
      text,
      className: dataClassName,
      action,
      link,
      dataLabel
    }
  } = props;
  const classProps = {
    className: [dataClassName, action, className].filter(Boolean).join(' ')
  };
  const trackingProps = dataLabel ? {
    'data-tracking': true,
    'data-action': 'Click',
    'data-label': `${dataLabel}`
  } : null;
  const btnProps = {
    ...classProps,
    ...trackingProps
  };
  if (props.handleClick) {
    btnProps.onClick = props.handleClick;
  }
  if (link) {
    btnProps.href = link.href;
    if (link.target) {
      btnProps.target = link.target;
    }
    return /*#__PURE__*/_jsxs("a", {
      ...btnProps,
      children: [text.short && /*#__PURE__*/_jsx("span", {
        className: "visible-xs-inline-block visible-ms-inline-block",
        dangerouslySetInnerHTML: {
          __html: text.short
        }
      }), /*#__PURE__*/_jsx("span", {
        className: `${text.short ? 'hidden-xs hidden-ms' : ''}`,
        dangerouslySetInnerHTML: {
          __html: text.full
        }
      }), svgChevron && /*#__PURE__*/_jsx(CheveronRightIcon, {
        className: "ml-2"
      })]
    });
  }
  return /*#__PURE__*/_jsxs("button", {
    ...btnProps,
    children: [text.short && /*#__PURE__*/_jsx("span", {
      className: "visible-xs-inline-block visible-ms-inline-block",
      dangerouslySetInnerHTML: {
        __html: text.short
      }
    }), /*#__PURE__*/_jsx("span", {
      className: `${text.short ? 'hidden-xs hidden-ms' : ''}`,
      dangerouslySetInnerHTML: {
        __html: text.full
      }
    }), svgChevron && /*#__PURE__*/_jsx(CheveronRightIcon, {
      className: "ml-2"
    })]
  });
};
export default Button;